import { FORM_ERROR } from "final-form";
import React from "react";
import { Form as FinalForm } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { Link, Redirect } from "react-router-dom";
import { Col, Container, Row, Spinner } from "reactstrap";

import Footer from "src/components/Footer/Footer";
import TextField from "../../components/Form/TextFieldV2/TextFieldV2";
import * as S from "../../constants/StringConstants";
import { IRootState } from "../../store/reducers";
import { login } from "../../store/reducers/authentication";
import "./Login.scss";

interface LoginFormValues {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const isAuthenticated = useSelector((state: IRootState) => state.auth.isAuthenticated);

  const onSubmit = async (values: LoginFormValues) => {
    const { email, password } = values;

    try {
      await dispatch<any>(login(email, password));
      history.push("/");
    } catch (error) {
      return {
        [FORM_ERROR]: S.LOGIN_FAILED_MESSAGE,
      };
    }
  };

  const { from } = (location.state as any) || {
    from: { pathname: "/", search: location.search },
  };

  if (isAuthenticated) {
    return <Redirect to={from} />;
  }

  return (
    <section className="login">
      <Container fluid>
        <Row>
          <Col md={7} className="login__logo-container" />
          <Col md={5} className="login__form-container">
            <div className="login__form-wrap">
              <div className="login__form-content">
                <FinalForm
                  onSubmit={onSubmit}
                  render={({ handleSubmit, submitFailed, submitting }) => {
                    return (
                      <form noValidate className="login__form" onSubmit={handleSubmit}>
                        {submitFailed && <div className="not-valid">{S.LOGIN_FAILED_MESSAGE}</div>}

                        <TextField
                          label={S.EMAIL_LABEL}
                          placeholder={S.EMAIL_PLACEHOLDER}
                          name="email"
                          type="email"
                          light={false}
                          validate={value => (value ? undefined : S.FORM_FIELD_REQUIRED)}
                        />

                        <TextField
                          label={S.LOGIN_PASSWORD}
                          placeholder={S.LOGIN_PASSWORD_PLACEHOLDER}
                          name="password"
                          type="password"
                          light={false}
                          validate={value => (value ? undefined : S.LOGIN_PASSWORD_REQUIRED)}
                        />

                        <button className="button-v2 primary" type="submit" disabled={submitting}>
                          {submitting ? <Spinner color="light" /> : S.LOGIN_SIGN_IN}
                        </button>
                      </form>
                    );
                  }}
                />
                <div className="login__forgot-pwd">
                  <Link to="/forgot-password">{S.LOGIN_FORGOT_PASSWORD}</Link>
                </div>
              </div>

              <Footer />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Login;
